import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import * as Sentry from '@sentry/angular';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { filterSentryEvent } from './sentry-event-filter';

if (environment.production) {
  enableProdMode();
}

Sentry.init({
  dsn: 'https://4dcf4c30ca30f52cf60748de7bd70e4b@sentry.thelegogroup.com/4511665528963152',
  environment: environment.environmentName,
  release: environment.version,
  integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
  propagateTraceparent: true,
  tracesSampleRate: 1.0,
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 1.0,
  beforeSend: filterSentryEvent,
});

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => {
    console.error(err);
  });
